import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { HELP_HINTS } from "@/lib/helpContent";

// A single "?" popover with 2–3 sentences and a link to the matching help article.
// Place exactly one per major surface, in the header area.
export function HelpHint({ topic, dark = false, className = "" }) {
  const h = HELP_HINTS[topic];
  if (!h) return null;
  const color = dark
    ? "text-white/60 hover:text-white hover:bg-white/10"
    : "text-[#94A3B8] hover:text-brand hover:bg-[#F1F5F9]";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={`help-hint-${topic}`}
          aria-label={h.title}
          className={`grid place-items-center h-8 w-8 rounded-full transition-colors ${color} ${className}`}
        >
          <HelpCircle size={18} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 z-50" data-testid={`help-hint-popover-${topic}`}>
        <p className="font-heading font-semibold text-navy text-sm">{h.title}</p>
        <p className="mt-1.5 text-sm text-[#475569] leading-relaxed">{h.body}</p>
        <Link
          to={`/help#${h.slug}`}
          data-testid={`help-hint-link-${topic}`}
          className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-brand hover:underline"
        >
          Learn more →
        </Link>
      </PopoverContent>
    </Popover>
  );
}
